var map = {
	"./Language.svg": [
		67905,
		67905
	],
	"./License-fill.svg": [
		73745,
		73745
	],
	"./License.svg": [
		6774,
		6774
	],
	"./Pushpin-fill.svg": [
		3154,
		3154
	],
	"./Telegram-logo-fill.svg": [
		93118,
		93118
	],
	"./Unlock-fill.svg": [
		85418,
		85418
	],
	"./Unlock-small-Fill.svg": [
		24039,
		24039
	],
	"./Unlock-small.svg": [
		39429,
		39429
	],
	"./Unlock.svg": [
		92364,
		92364
	],
	"./add-story-fill.svg": [
		35369,
		35369
	],
	"./add-story.svg": [
		9533,
		9533
	],
	"./alarm-clock-fill.svg": [
		99444,
		99444
	],
	"./alarm-clock.svg": [
		70530,
		70530
	],
	"./archive-fill.svg": [
		84824,
		84824
	],
	"./arrow-capsulepath.svg": [
		87110,
		87110
	],
	"./arrow-circlepath.svg": [
		52014,
		52014
	],
	"./arrow-down-left-fill.svg": [
		72498,
		72498
	],
	"./arrow-down-left.svg": [
		6676,
		6676
	],
	"./arrow-down-line.svg": [
		77730,
		77730
	],
	"./arrow-down.svg": [
		64587,
		64587
	],
	"./arrow-left.svg": [
		16505,
		16505
	],
	"./arrow-right-fill.svg": [
		19818,
		19818
	],
	"./arrow-right-from-blue-dot.svg": [
		96488,
		96488
	],
	"./arrow-right-from-line.svg": [
		26256,
		26256
	],
	"./arrow-right.svg": [
		68515,
		68515
	],
	"./arrow-top-right-1.svg": [
		56466,
		56466
	],
	"./arrow-top-right-question-fill.svg": [
		55202,
		55202
	],
	"./arrow-top-right-question.svg": [
		97276,
		97276
	],
	"./arrow-top-right.svg": [
		81855,
		81855
	],
	"./arrow-two-circlepath-horizontal.svg": [
		80993,
		80993
	],
	"./arrow-two-circlepath-vertical.svg": [
		66708,
		66708
	],
	"./arrow-two-circlepath-vetical.svg": [
		76034,
		76034
	],
	"./arrow-two-rectanglepath-horizontal.svg": [
		61673,
		61673
	],
	"./arrow-up-arrow-down-small.svg": [
		19939,
		19939
	],
	"./arrow-up-arrow-down.svg": [
		33178,
		33178
	],
	"./arrow-up-right.svg": [
		48686,
		48686
	],
	"./arrow-up.svg": [
		24699,
		24699
	],
	"./arrow-upward-trend.svg": [
		57861,
		57861
	],
	"./attach-file.svg": [
		15264,
		15264
	],
	"./banknote-fill.svg": [
		90834,
		90834
	],
	"./banknote-two-fill.svg": [
		71400,
		71400
	],
	"./banknote-two.svg": [
		95538,
		95538
	],
	"./banknote.svg": [
		24265,
		24265
	],
	"./battery-exclamation.svg": [
		22059,
		22059
	],
	"./battery.svg": [
		23906,
		23906
	],
	"./bazzarpay-logo.svg": [
		23076,
		23076
	],
	"./bell-dot-fill.svg": [
		81453,
		81453
	],
	"./bell-fill.svg": [
		74135,
		74135
	],
	"./bell.svg": [
		98543,
		98543
	],
	"./bookmark-fill.svg": [
		69563,
		69563
	],
	"./bookmark.svg": [
		36187,
		36187
	],
	"./box-check.svg": [
		86997,
		86997
	],
	"./box-fill.svg": [
		6953,
		6953
	],
	"./box-slash-fill.svg": [
		15174,
		15174
	],
	"./box.svg": [
		25644,
		25644
	],
	"./briefcase-fill.svg": [
		81225,
		81225
	],
	"./briefcase.svg": [
		15207,
		15207
	],
	"./building-fill.svg": [
		26507,
		26507
	],
	"./building.svg": [
		44622,
		44622
	],
	"./calendar-fill.svg": [
		29136,
		29136
	],
	"./calendar.svg": [
		29390,
		29390
	],
	"./call-dialog-box.svg": [
		34810,
		34810
	],
	"./call-left-slash.svg": [
		7376,
		7376
	],
	"./call-left.svg": [
		8455,
		8455
	],
	"./call-righ.svg": [
		94699,
		94699
	],
	"./call-right-slash.svg": [
		97370,
		97370
	],
	"./call-safe-left.svg": [
		45403,
		45403
	],
	"./call-safe-right.svg": [
		60968,
		60968
	],
	"./camera-fill.svg": [
		97259,
		97259
	],
	"./camera-plus.svg": [
		66296,
		66296
	],
	"./camera.svg": [
		23545,
		23545
	],
	"./car-clock-fill.svg": [
		47130,
		47130
	],
	"./car-clock.svg": [
		26399,
		26399
	],
	"./car-fill.svg": [
		47323,
		47323
	],
	"./car-slash-fill.svg": [
		83167,
		83167
	],
	"./car-slash.svg": [
		99914,
		99914
	],
	"./car-spark.svg": [
		70405,
		70405
	],
	"./car.svg": [
		21963,
		21963
	],
	"./card-fill.svg": [
		36000,
		36000
	],
	"./card-left-arrow-fill.svg": [
		43686,
		43686
	],
	"./card-left-arrow.svg": [
		30554,
		30554
	],
	"./card-plus-fill.svg": [
		52851,
		52851
	],
	"./card-plus.svg": [
		68205,
		68205
	],
	"./card-right-arrow-fill.svg": [
		17623,
		17623
	],
	"./card-right-arrow.svg": [
		47257,
		47257
	],
	"./card-spark-fill.svg": [
		20793,
		20793
	],
	"./card-spark.svg": [
		66430,
		66430
	],
	"./card-time-fill.svg": [
		73100,
		73100
	],
	"./card-time.svg": [
		8841,
		8841
	],
	"./card.svg": [
		29853,
		29853
	],
	"./check-bold.svg": [
		62445,
		62445
	],
	"./check-fill.svg": [
		10943,
		10943
	],
	"./check-variant.svg": [
		32411,
		32411
	],
	"./check.svg": [
		98696,
		98696
	],
	"./chevron-down-fill.svg": [
		88379,
		88379
	],
	"./chevron-down.svg": [
		24821,
		24821
	],
	"./chevron-left-fill.svg": [
		51267,
		51267
	],
	"./chevron-left.svg": [
		99265,
		99265
	],
	"./chevron-right-fill.svg": [
		10132,
		10132
	],
	"./chevron-right.svg": [
		7107,
		7107
	],
	"./chevron-up-fill.svg": [
		42185,
		42185
	],
	"./chevron-up.svg": [
		77955,
		77955
	],
	"./circle-check-fill.svg": [
		98305,
		98305
	],
	"./circle-check-small-fill.svg": [
		40941,
		40941
	],
	"./circle-check-small.svg": [
		49502,
		49502
	],
	"./circle-check.svg": [
		89528,
		89528
	],
	"./circle-cross-fill.svg": [
		72210,
		72210
	],
	"./circle-cross.svg": [
		91982,
		91982
	],
	"./circle-exclamation-fill.svg": [
		91972,
		91972
	],
	"./circle-exclamation.svg": [
		21222,
		21222
	],
	"./circle-information-fill.svg": [
		5042,
		5042
	],
	"./circle-information.svg": [
		45229,
		45229
	],
	"./circle-minus-fill.svg": [
		29365,
		29365
	],
	"./circle-minus.svg": [
		24921,
		24921
	],
	"./circle-more-fill.svg": [
		53205,
		53205
	],
	"./circle-person-fill-1.svg": [
		96387,
		96387
	],
	"./circle-person-fill.svg": [
		26232,
		26232
	],
	"./circle-person.svg": [
		58072,
		58072
	],
	"./circle-plus-fill.svg": [
		64055,
		64055
	],
	"./circle-plus.svg": [
		59212,
		59212
	],
	"./circle-question-fill.svg": [
		4482,
		4482
	],
	"./circle-star-fill.svg": [
		31734,
		31734
	],
	"./circle-star.svg": [
		5925,
		5925
	],
	"./circle-thunder-fill.svg": [
		88422,
		88422
	],
	"./circle-thunder.svg": [
		52762,
		52762
	],
	"./clipboard-clock-fill.svg": [
		99183,
		99183
	],
	"./clipboard-clock.svg": [
		42835,
		42835
	],
	"./clips-together.svg": [
		96989,
		96989
	],
	"./clock-arrow-circlepath-orange.svg": [
		17656,
		17656
	],
	"./clock-arrow-circlepath.svg": [
		11738,
		11738
	],
	"./clock-dashed.svg": [
		77901,
		77901
	],
	"./clock-fill.svg": [
		4241,
		4241
	],
	"./clock-small-fill.svg": [
		15255,
		15255
	],
	"./clock-small.svg": [
		26726,
		26726
	],
	"./clock.svg": [
		89276,
		89276
	],
	"./co2-circle.svg": [
		13821,
		13821
	],
	"./co2.svg": [
		86957,
		86957
	],
	"./conversation.svg": [
		67654,
		67654
	],
	"./copy-fill.svg": [
		19182,
		19182
	],
	"./copy.svg": [
		69742,
		69742
	],
	"./coupon-fill.svg": [
		32889,
		32889
	],
	"./coupon-puched-fill.svg": [
		3764,
		3764
	],
	"./coupon-puched.svg": [
		97519,
		97519
	],
	"./coupon.svg": [
		52519,
		52519
	],
	"./cross-bold.svg": [
		1762,
		1762
	],
	"./cross-fill.svg": [
		62248,
		62248
	],
	"./cross.svg": [
		48187,
		48187
	],
	"./default-fill.svg": [
		60067,
		60067
	],
	"./default.svg": [
		59163,
		59163
	],
	"./delete-left-fill.svg": [
		23248,
		23248
	],
	"./delete-left.svg": [
		78281,
		78281
	],
	"./dialog-box-text-fill-left.svg": [
		58526,
		58526
	],
	"./dialog-box-text-fill.svg": [
		35031,
		35031
	],
	"./dialog-box-text-left-fill-round.svg": [
		65699,
		65699
	],
	"./dialog-box-text-left-fill.svg": [
		25408,
		25408
	],
	"./dialog-box-text-left.svg": [
		66,
		66
	],
	"./dialog-box-text-right-fill.svg": [
		15981,
		15981
	],
	"./dialog-box-text-right.svg": [
		13694,
		13694
	],
	"./dialog-box-text.svg": [
		67567,
		67567
	],
	"./dialogbox-question.svg": [
		99798,
		99798
	],
	"./diamond-arrow-turn-right-1.svg": [
		88573,
		88573
	],
	"./diamond-arrow-turn-right-fill.svg": [
		3612,
		3612
	],
	"./diamond-arrow-turn-right.svg": [
		63415,
		63415
	],
	"./dot-fill.svg": [
		43897,
		43897
	],
	"./double-check.svg": [
		81150,
		81150
	],
	"./ear-slash.svg": [
		94357,
		94357
	],
	"./envelope-fill.svg": [
		8572,
		8572
	],
	"./envelope-open-fill.svg": [
		54270,
		54270
	],
	"./envelope-open.svg": [
		39405,
		39405
	],
	"./envelope.svg": [
		21328,
		21328
	],
	"./exclamation-bold.svg": [
		4201,
		4201
	],
	"./exclamation-fill.svg": [
		47907,
		47907
	],
	"./exclamation.svg": [
		9681,
		9681
	],
	"./eye-fill.svg": [
		49851,
		49851
	],
	"./eye-slash-fill.svg": [
		44589,
		44589
	],
	"./eye-slash-stripes.svg": [
		99673,
		99673
	],
	"./eye-slash.svg": [
		69157,
		69157
	],
	"./eye.svg": [
		9649,
		9649
	],
	"./face-sad-fill.svg": [
		92879,
		92879
	],
	"./face-sad.svg": [
		72786,
		72786
	],
	"./face-smile-fill.svg": [
		21011,
		21011
	],
	"./face-smile.svg": [
		39719,
		39719
	],
	"./fact-check-fill.svg": [
		69019,
		69019
	],
	"./fact_check.svg": [
		14495,
		14495
	],
	"./finger-left-fill.svg": [
		83284,
		83284
	],
	"./finger-swipe-vertical.svg": [
		1966,
		1966
	],
	"./finger-touch.svg": [
		51250,
		51250
	],
	"./finger-up-fill.svg": [
		84678,
		84678
	],
	"./fire-fill.svg": [
		39252,
		39252
	],
	"./fire.svg": [
		20683,
		20683
	],
	"./flag-fill.svg": [
		76249,
		76249
	],
	"./flag.svg": [
		2090,
		2090
	],
	"./garage-logo.svg": [
		83176,
		83176
	],
	"./gas-station-fill.svg": [
		65217,
		65217
	],
	"./gas-station.svg": [
		67794,
		67794
	],
	"./gear-fill.svg": [
		58654,
		58654
	],
	"./gear.svg": [
		90561,
		90561
	],
	"./gift.svg": [
		95914,
		95914
	],
	"./globe.svg": [
		12258,
		12258
	],
	"./graduation-cap-fill.svg": [
		53259,
		53259
	],
	"./graduation-cap.svg": [
		83153,
		83153
	],
	"./headphone-fill.svg": [
		46833,
		46833
	],
	"./headphone.svg": [
		94000,
		94000
	],
	"./heart-broken-fill.svg": [
		11508,
		11508
	],
	"./heart-fill.svg": [
		5325,
		5325
	],
	"./heart.svg": [
		83419,
		83419
	],
	"./helmets-fill-rtl.svg": [
		90523,
		90523
	],
	"./helmets-fill.svg": [
		72831,
		72831
	],
	"./helmets-rtl.svg": [
		50328,
		50328
	],
	"./helmets.svg": [
		74641,
		74641
	],
	"./home-fill.svg": [
		33329,
		33329
	],
	"./home-health.svg": [
		50719,
		50719
	],
	"./home.svg": [
		75464,
		75464
	],
	"./hourglass-fill.svg": [
		39136,
		39136
	],
	"./hourglass.svg": [
		72310,
		72310
	],
	"./image-fill.svg": [
		95524,
		95524
	],
	"./image-two-fill.svg": [
		92418,
		92418
	],
	"./image-two.svg": [
		89665,
		89665
	],
	"./image.svg": [
		51883,
		51883
	],
	"./info-bold.svg": [
		3701,
		3701
	],
	"./info-fill.svg": [
		39537,
		39537
	],
	"./info.svg": [
		49045,
		49045
	],
	"./instagram-logo-fill.svg": [
		50761,
		50761
	],
	"./instagram-logo.svg": [
		60806,
		60806
	],
	"./keyboard-fill.svg": [
		68014,
		68014
	],
	"./keyboard.svg": [
		21364,
		21364
	],
	"./lamp-spark-fill.svg": [
		4344,
		4344
	],
	"./leaf-fill.svg": [
		67238,
		67238
	],
	"./leaf.svg": [
		97422,
		97422
	],
	"./lightning-bolt.svg": [
		73841,
		73841
	],
	"./line-three-horizontal-decrease.svg": [
		81057,
		81057
	],
	"./line-three.svg": [
		63687,
		63687
	],
	"./list-bullet.svg": [
		88723,
		88723
	],
	"./loading-spinner.svg": [
		21941,
		21941
	],
	"./loading.svg": [
		66683,
		66683
	],
	"./location-left.svg": [
		67882,
		67882
	],
	"./location-top-right-fill.svg": [
		43936,
		43936
	],
	"./location-top-right-question-fill.svg": [
		15093,
		15093
	],
	"./location-top-right-question.svg": [
		59601,
		59601
	],
	"./location-top-right.svg": [
		7063,
		7063
	],
	"./location-up.svg": [
		72384,
		72384
	],
	"./lock-fill.svg": [
		16764,
		16764
	],
	"./lock-small-fill.svg": [
		82000,
		82000
	],
	"./lock-small.svg": [
		55777,
		55777
	],
	"./lock.svg": [
		57484,
		57484
	],
	"./luggage-fill.svg": [
		43592,
		43592
	],
	"./luggage.svg": [
		65604,
		65604
	],
	"./magnifier-fill.svg": [
		30625,
		30625
	],
	"./magnifier.svg": [
		74086,
		74086
	],
	"./map-fill.svg": [
		68691,
		68691
	],
	"./map.svg": [
		30027,
		30027
	],
	"./medal-1.svg": [
		84074,
		84074
	],
	"./medal-fill-1.svg": [
		57007,
		57007
	],
	"./medal-fill.svg": [
		35703,
		35703
	],
	"./medal-variant-fill.svg": [
		41522,
		41522
	],
	"./medal-variant.svg": [
		72375,
		72375
	],
	"./medal.svg": [
		92691,
		92691
	],
	"./microphone-fill.svg": [
		11245,
		11245
	],
	"./microphone-slash-fill.svg": [
		92102,
		92102
	],
	"./microphone-slash.svg": [
		1243,
		1243
	],
	"./microphone-spark-fill.svg": [
		26172,
		26172
	],
	"./microphone-spark.svg": [
		15217,
		15217
	],
	"./microphone.svg": [
		89005,
		89005
	],
	"./minus-bold.svg": [
		20221,
		20221
	],
	"./minus-fill.svg": [
		18681,
		18681
	],
	"./minus.svg": [
		8438,
		8438
	],
	"./moon-fill.svg": [
		17213,
		17213
	],
	"./moon.svg": [
		33051,
		33051
	],
	"./more-horizontal-bold.svg": [
		30399,
		30399
	],
	"./more-horizontal-fill.svg": [
		7521,
		7521
	],
	"./more-horizontal.svg": [
		52539,
		52539
	],
	"./more-vertical-bold.svg": [
		66037,
		66037
	],
	"./more-vertical-fill.svg": [
		33732,
		33732
	],
	"./more-vertical.svg": [
		69685,
		69685
	],
	"./motorcycle.svg": [
		29303,
		29303
	],
	"./pause-circle-fill.svg": [
		75088,
		75088
	],
	"./pause-circle.svg": [
		85674,
		85674
	],
	"./pause.svg": [
		20349,
		20349
	],
	"./payment.svg": [
		91405,
		91405
	],
	"./pencil-line-fill.svg": [
		31555,
		31555
	],
	"./pencil-line.svg": [
		25214,
		25214
	],
	"./person-1.svg": [
		14611,
		14611
	],
	"./person-fill-1.svg": [
		4754,
		4754
	],
	"./person-fill.svg": [
		74953,
		74953
	],
	"./person-in-wheelchair.svg": [
		34020,
		34020
	],
	"./person-minus-fill.svg": [
		31935,
		31935
	],
	"./person-minus.svg": [
		25355,
		25355
	],
	"./person-plus-fill.svg": [
		42809,
		42809
	],
	"./person-plus.svg": [
		41632,
		41632
	],
	"./person-two-fill.svg": [
		71703,
		71703
	],
	"./person-two.svg": [
		32557,
		32557
	],
	"./person-variant-fill.svg": [
		38142,
		38142
	],
	"./person-variant.svg": [
		47165,
		47165
	],
	"./person-wave-fill.svg": [
		69645,
		69645
	],
	"./person-wave.svg": [
		48133,
		48133
	],
	"./person.svg": [
		13654,
		13654
	],
	"./phone-fill.svg": [
		21754,
		21754
	],
	"./phone-ondemand.svg": [
		33277,
		33277
	],
	"./phone-scheduled.svg": [
		15307,
		15307
	],
	"./phone-vibrate-fill.svg": [
		52516,
		52516
	],
	"./phone-vibrate.svg": [
		26893,
		26893
	],
	"./phone.svg": [
		55419,
		55419
	],
	"./pin-circle-fill.svg": [
		65820,
		65820
	],
	"./pin-circle.svg": [
		93793,
		93793
	],
	"./pin-cross-fill.svg": [
		97206,
		97206
	],
	"./pin-cross.svg": [
		53534,
		53534
	],
	"./pin-fill.svg": [
		32032,
		32032
	],
	"./pin-on-map-fill.svg": [
		9630,
		9630
	],
	"./pin-on-map.svg": [
		22231,
		22231
	],
	"./pin-wave-fill.svg": [
		29000,
		29000
	],
	"./pin-wave.svg": [
		39102,
		39102
	],
	"./plane-fill.svg": [
		76519,
		76519
	],
	"./plane.svg": [
		65525,
		65525
	],
	"./planet-earth.svg": [
		11604,
		11604
	],
	"./play-circle-fill.svg": [
		73188,
		73188
	],
	"./play-circle.svg": [
		92050,
		92050
	],
	"./play.svg": [
		11472,
		11472
	],
	"./plus-bold.svg": [
		18523,
		18523
	],
	"./plus-fill.svg": [
		48305,
		48305
	],
	"./plus.svg": [
		40019,
		40019
	],
	"./point-three-connected-line-fill.svg": [
		34446,
		34446
	],
	"./point-three-connected-line.svg": [
		44633,
		44633
	],
	"./point-three-connected-trianglepath-line-fill.svg": [
		69679,
		69679
	],
	"./point-three-connected-trianglepath-line.svg": [
		35368,
		35368
	],
	"./pollution-zone.svg": [
		31696,
		31696
	],
	"./power.svg": [
		76180,
		76180
	],
	"./question.svg": [
		29760,
		29760
	],
	"./ratio-horizontal-fill.svg": [
		49383,
		49383
	],
	"./ratio-horizontal.svg": [
		49700,
		49700
	],
	"./ratio-square-fill.svg": [
		66408,
		66408
	],
	"./ratio-square.svg": [
		63320,
		63320
	],
	"./ratio-vertical-fill.svg": [
		24912,
		24912
	],
	"./ratio-vertical.svg": [
		42417,
		42417
	],
	"./record.svg": [
		74634,
		74634
	],
	"./rectangle-person-text-with-badge.svg": [
		14775,
		14775
	],
	"./scan-fill.svg": [
		76241,
		76241
	],
	"./scan.svg": [
		98593,
		98593
	],
	"./schedule.svg": [
		42761,
		42761
	],
	"./send-chat-fill.svg": [
		58672,
		58672
	],
	"./send-chat.svg": [
		6106,
		6106
	],
	"./share-fill.svg": [
		4350,
		4350
	],
	"./share.svg": [
		86745,
		86745
	],
	"./shield-1.svg": [
		8792,
		8792
	],
	"./shield-check-fill.svg": [
		57063,
		57063
	],
	"./shield-check.svg": [
		34854,
		71120
	],
	"./shield-fill.svg": [
		76846,
		76846
	],
	"./shield.svg": [
		16781,
		16781
	],
	"./shopping-bag-fill.svg": [
		11481,
		11481
	],
	"./shopping-bag.svg": [
		36756,
		36756
	],
	"./shopping-cart-fill-ltr.svg": [
		7430,
		7430
	],
	"./shopping-cart-fill.svg": [
		61882,
		61882
	],
	"./shopping-cart-ltr.svg": [
		17947,
		17947
	],
	"./shopping-cart.svg": [
		14194,
		14194
	],
	"./silence.svg": [
		41862,
		41862
	],
	"./single-check.svg": [
		51783,
		51783
	],
	"./siren-fill.svg": [
		91164,
		91164
	],
	"./siren.svg": [
		33381,
		33381
	],
	"./slider-horizontal-fill.svg": [
		57330,
		57330
	],
	"./slider-horizontal.svg": [
		35839,
		35839
	],
	"./spark-fill.svg": [
		70887,
		70887
	],
	"./spark-small-fill.svg": [
		52011,
		52011
	],
	"./spark-small.svg": [
		41633,
		41633
	],
	"./spark-three-fill.svg": [
		27700,
		70899
	],
	"./spark-three.svg": [
		63862,
		63862
	],
	"./spark.svg": [
		686,
		686
	],
	"./speaker-cross.svg": [
		70485,
		70485
	],
	"./speaker-exclamation.svg": [
		81094,
		81094
	],
	"./speaker-wave.svg": [
		86297,
		86297
	],
	"./spiral-dot-two.svg": [
		21613,
		21613
	],
	"./square- category-fill.svg": [
		81444,
		81444
	],
	"./square-above-squares.svg": [
		68576,
		68576
	],
	"./square-category.svg": [
		69794,
		69794
	],
	"./square-fill.svg": [
		63698,
		63698
	],
	"./square-four-fill.svg": [
		41879,
		41879
	],
	"./square-four.svg": [
		92281,
		92281
	],
	"./square-grid-fill.svg": [
		12975,
		12975
	],
	"./square-grid-rounded-fill.svg": [
		61083,
		61083
	],
	"./square-grid-rounded.svg": [
		18934,
		18934
	],
	"./square-grid.svg": [
		35327,
		35327
	],
	"./square-more-fill.svg": [
		39489,
		39489
	],
	"./square-more.svg": [
		74832,
		74832
	],
	"./square-person-fill.svg": [
		72577,
		72577
	],
	"./square-person.svg": [
		7526,
		7526
	],
	"./star-fill.svg": [
		96980,
		96980
	],
	"./star.svg": [
		74045,
		74045
	],
	"./steer-fill.svg": [
		73233,
		73233
	],
	"./steer.svg": [
		39851,
		39851
	],
	"./stethoscope.svg": [
		28858,
		28858
	],
	"./sticky-note-fill.svg": [
		12741,
		12741
	],
	"./sticky-note.svg": [
		90043,
		90043
	],
	"./store-fill.svg": [
		12583,
		12583
	],
	"./store.svg": [
		86224,
		86224
	],
	"./sun-fill.svg": [
		7105,
		7105
	],
	"./sun.svg": [
		20769,
		20769
	],
	"./tapsi-logo.svg": [
		99432,
		99432
	],
	"./tara-logo.svg": [
		74668,
		74668
	],
	"./target-fill.svg": [
		89763,
		89763
	],
	"./target-slash.svg": [
		37190,
		37190
	],
	"./target.svg": [
		91100,
		91100
	],
	"./telephone-fill.svg": [
		18844,
		18844
	],
	"./telephone.svg": [
		62938,
		62938
	],
	"./thumb-down-fill.svg": [
		73560,
		73560
	],
	"./thumb-down.svg": [
		95937,
		95937
	],
	"./thumb-up-fill.svg": [
		52720,
		52720
	],
	"./thumb-up.svg": [
		43068,
		43068
	],
	"./thunder.svg": [
		42018,
		42018
	],
	"./timer-fill.svg": [
		22472,
		22472
	],
	"./timer.svg": [
		19529,
		19529
	],
	"./traffic-control-zone-fill.svg": [
		48781,
		48781
	],
	"./traffic-light-fill.svg": [
		41957,
		41957
	],
	"./traffic-light.svg": [
		41317,
		41317
	],
	"./trash-fill.svg": [
		7195,
		7195
	],
	"./trash.svg": [
		96222,
		96222
	],
	"./triangle-exclamation-fill.svg": [
		31803,
		31803
	],
	"./triangle-exclamation.svg": [
		42931,
		42931
	],
	"./trophy-fill.svg": [
		92822,
		92822
	],
	"./trophy.svg": [
		62509,
		62509
	],
	"./ufo-fill.svg": [
		82288,
		82288
	],
	"./ufo.svg": [
		48281,
		48281
	],
	"./video-two-fill.svg": [
		57765,
		57765
	],
	"./video-two.svg": [
		22408,
		22408
	],
	"./wallet-fill.svg": [
		35074,
		35074
	],
	"./wallet-swap.svg": [
		76750,
		76750
	],
	"./wallet.svg": [
		52952,
		52952
	],
	"./warning.svg": [
		37974,
		37974
	],
	"./wifi-slash.svg": [
		77670,
		77670
	],
	"./wifi.svg": [
		81160,
		81160
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 53780;
module.exports = webpackAsyncContext;